import { ChangeDetectionStrategy, ChangeDetectorRef, Component,EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { HardCopyConstants } from '../hard-copy.constants';
import { DeleteHardCopyDTO } from '../models/delete-hardcopy-activity-DTO';
import { HardCopyActivityService } from '../services/hard-copy-activity.service';

@Component({
  selector: 'app-delete-hard-copy',
  templateUrl: './delete-hard-copy.component.html',
  styleUrls: ['./delete-hard-copy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteHardCopyComponent implements OnInit {
  mandatoryFields = this.getDefaultMandatoryFieldsObject();
  ReasonData:any='';
  errorMessages: any = [];
  deleteHardCopyData!:DeleteHardCopyDTO;
  mandatoryReasonText:any = HardCopyConstants.HardCopyActivity_Reason_Required;
  @Input() hardcopyActivityId : any;
  @Output() closeDeleteModal = new EventEmitter<boolean>();
  @Input() closeDeleteModalVisible!:boolean;
  constructor(private hardCopyActivityService: HardCopyActivityService,private messageService: MessageService,private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.deleteHardCopyData={
      reason:null
    };
  }
  reloadHardCopyDetail():void
  {
    this.closeDeleteModalVisible=false;
    this.ReasonData='';
    this.errorMessages = [];
    this.closeDeleteModal.emit(this.closeDeleteModalVisible);
  }
  private getDefaultMandatoryFieldsObject() {
    return {
      reason: false
    };
  }
  confirmClick(buttonClick:any):void
  {
    this.errorMessages = [];
    if(this.ReasonData.trim() === '')
    {
      this.errorMessages.push(this.mandatoryReasonText);
    }
    else
    {
      this.deleteHardCopyData.reason=this.ReasonData;
      this.hardCopyActivityService.deleteHardcopyActivity(this.hardcopyActivityId,this.deleteHardCopyData).subscribe(
        serviceData => {
          this.messageService.add({
            severity: HardCopyConstants.Severity_Info,
            summary: HardCopyConstants.HardCopyActivity_Deleted_Success
          });
          if(serviceData.isDeleted===true)
          {
            this.hardCopyActivityService.hardcopyActivityDeleted.next(true);
            this.cd.detectChanges();
            this.reloadHardCopyDetail();
          }
        });
    }
    
  }
  cancelClick():void{
    this.closeDeleteModalVisible=false;
    this.ReasonData='';
    this.errorMessages = [];
    this.closeDeleteModal.emit(this.closeDeleteModalVisible);
  }
}
